import {
  ADD_TO_CART,
  REMOVE_FROM_CART,
  RESET_CART,
  USER_ORDERS,
  USER_DETAILS,
  SET_PRODUCT_MINIMUM_VALUE,
  RESONATE_EXCLUSIVE_LIST,
  RESONATE_EXCLUSIVE_FILTER,
  SHOP_ONLINE_FILTER,
  SHOP_ONLINE_LIST,
  ADD_ITEMS_TO_CART,
  SET_QR_CODE,
  SET_USER_ID
} from "./actionTypes";

const initState = {
  products: [],
  food: [],
  userId: "",
  qrCode: "",
  resonateExclusive: [],
  filterResonateExclusive: [],
  shopOnline: [],
  filterShopOnline: [],
  user: null,
  cart: [],
  orders: [],
  cartCount: 0,
  totalValue: 0,
  minValue: 0,
  filter: "All Items",
  filterName: "",
  disclaimer: "The images on the site are for illustrative purposes only.",
  filterProducts: [],
  menu: ["Auctions", "FAQ'S", "Contact Us"]
};
const reducer = (state = initState, action) => {
  
  if (action.type === RESONATE_EXCLUSIVE_LIST) {
    state.resonateExclusive = action.resonateExclusive;
    state.filterResonateExclusive = action.resonateExclusive;
    return {
      ...state
    };
  }

  if (action.type === RESONATE_EXCLUSIVE_FILTER) {
    
    state.filterName = action.filterName;
    state.filterResonateExclusive = state.resonateExclusive.filter(
      product => action.filterName === product.category
    );
    return {
      ...state
    };
  
  }


  if (action.type === SHOP_ONLINE_LIST) {
    state.shopOnline = action.shopOnline;
    state.filterShopOnline = action.shopOnline;
    return {
      ...state
    };
  }

  if (action.type === SHOP_ONLINE_FILTER) {
    state.filterName = action.filterName;
    state.filterShopOnline = state.shopOnline.filter(
      product => action.filterName === product.category
    );
    return {
      ...state
    };
  }


  if (action.type === ADD_ITEMS_TO_CART) {
    state.cartCount += 1;
    let shopOnlineProduct = state.shopOnline.find(
      product => product.productId === action.productId
    );

    let itemInCart = state.cart.find(
      product => product.productId === action.productId
    );

    if (!itemInCart) {
      shopOnlineProduct.count = 1;
      shopOnlineProduct.quantity -= 1;
      shopOnlineProduct.totalValue = shopOnlineProduct.value;
      state.totalValue = state.totalValue + shopOnlineProduct.value;
      state.cart = [...state.cart, shopOnlineProduct];
    } else {
      shopOnlineProduct.count += 1;
      shopOnlineProduct.quantity -= 1;
      shopOnlineProduct.totalValue += shopOnlineProduct.value;
      state.totalValue = state.totalValue + shopOnlineProduct.value;
    }

    return {
      ...state
    };
  }

  if (action.type === USER_DETAILS) {
    state.user = action.user;
    return {
      ...state
    };
  }

  if (action.type === USER_ORDERS) {
    state.orders = action.orders;
    return {
      ...state
    };
  }

  if (action.type === SET_PRODUCT_MINIMUM_VALUE) {
    state.minValue = action.minValue;
    return {
      ...state
    };
  }

  if (action.type === SET_QR_CODE) {
    state.qrCode = action.qrCode;
    return {
      ...state
    };
  }

  if (action.type === SET_USER_ID) {
    state.userId = action.userId;
    return {
      ...state
    };
  }

  if (action.type === ADD_TO_CART) {
    state.cartCount += 1;
    let cartProduct = state.products.find(
      product => product.productId === action.productId
    );
    let cartInProduct = state.cart.find(
      product => product.productId === action.productId
    );
    let orderItem = state.orders.find(
      order => order.productId === action.productId
    );

    if (!cartInProduct) {
      cartProduct.count = 1;
      cartProduct.quantity -= 1;
      cartProduct.totalValue = cartProduct.value;
      state.totalValue = state.totalValue + cartProduct.value;
      state.cart = [...state.cart, cartProduct];
    } else {
      cartProduct.count += 1;
      cartProduct.quantity -= 1;
      cartProduct.totalValue += cartProduct.value;
      state.totalValue = state.totalValue + cartProduct.value;
    }
    if (orderItem !== undefined) {
      orderItem.quantity += 1;
      state.orders = [...state.orders];
    }

    return {
      ...state
    };
  }

  if (action.type === REMOVE_FROM_CART) {
    let productToRemove = state.cart.find(
      product => action.productId === product.productId
    );

    //update cart
    state.cart = state.cart.filter(
      product => action.productId !== product.productId
    );

    state.totalValue = state.totalValue - productToRemove.totalValue;
    state.cartCount = state.cartCount - productToRemove.count;
    // update available items count

    state.shopOnline.find(
      product=> action.productId === product.productId
    ).quantity += productToRemove.count;

    // reset the car count to 0 for the product
    state.shopOnline.find(
      product=> action.productId === product.productId
    ).count = 0;

    return {
      ...state
    };
  }
  if (action.type === RESET_CART) {
    state = initState;
    return {
      ...state
    };
  } else {
    return {
      ...state
    };
  }
};
// refactor code

export default reducer;
